import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Trade from "@/pages/Trade";
import Makers from "@/pages/Makers";
import MakerProfile from "@/pages/MakerProfile";
import Verified from "@/pages/Verified";
import About from "@/pages/About";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Navigate to="/makers" replace />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/makers" element={<Makers />} />
            <Route path="/makers/:slug" element={<MakerProfile />} />
            <Route path="/verified" element={<Verified />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "var(--ovi-cream-2)",
            color: "var(--ovi-ink)",
            border: "1px solid var(--ovi-border)",
          },
        }}
      />
    </div>
  );
}

export default App;
